"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFloatingLinkEditState = exports.useFloatingLinkEdit = void 0;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _useFloatingLinkEnter = require("./useFloatingLinkEnter");
var _useFloatingLinkEscape = require("./useFloatingLinkEscape");
var _useVirtualFloatingLink = require("./useVirtualFloatingLink");
var _plateLink = require("@udecode/plate-link");
var _index = require("../forks/floating/index");
var useFloatingLinkEditState = function useFloatingLinkEditState() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    floatingOptions = _ref2.floatingOptions;
  var editor = (0, _plateCommon.useEditorRef)();
  var _ref3 = (0, _plateCommon.getPluginOptions)(editor, _plateLink.ELEMENT_LINK),
    triggerFloatingLinkHotkeys = _ref3.triggerFloatingLinkHotkeys;
  var readOnly = (0, _plateCommon.useEditorReadOnly)();
  var isEditing = (0, _plateLink.useFloatingLinkSelectors)().isEditing();
  var version = (0, _plateCommon.useEditorVersion)();
  var mode = (0, _plateLink.useFloatingLinkSelectors)().mode();
  var open = (0, _plateLink.useFloatingLinkSelectors)().isOpen(editor.id);
  var getBoundingClientRect = _react.default.useCallback(function () {
    var entry = (0, _plateCommon.getAboveNode)(editor, {
      match: {
        type: (0, _plateCommon.getPluginType)(editor, _plateLink.ELEMENT_LINK)
      }
    });
    if (entry) {
      var _entry = _slicedToArray(entry, 2),
        path = _entry[1];
      return (0, _index.getRangeBoundingClientRect)(editor, {
        anchor: (0, _plateCommon.getStartPoint)(editor, path),
        focus: (0, _plateCommon.getEndPoint)(editor, path)
      });
    }
    return (0, _index.getDefaultBoundingClientRect)();
  }, [editor]);
  var isOpen = open && mode === 'edit';
  var floating = (0, _useVirtualFloatingLink.useVirtualFloatingLink)(_objectSpread({
    editorId: editor.id,
    getBoundingClientRect: getBoundingClientRect,
    open: isOpen
  }, floatingOptions));
  return {
    editor: editor,
    floating: floating,
    isEditing: isEditing,
    isOpen: isOpen,
    readOnly: readOnly,
    triggerFloatingLinkHotkeys: triggerFloatingLinkHotkeys,
    versionEditor: version
  };
};
exports.useFloatingLinkEditState = useFloatingLinkEditState;
var useFloatingLinkEdit = function useFloatingLinkEdit(_ref) {
  var editor = _ref.editor,
    floating = _ref.floating,
    triggerFloatingLinkHotkeys = _ref.triggerFloatingLinkHotkeys,
    versionEditor = _ref.versionEditor;
  _react.default.useEffect(function () {
    if (editor.selection && (0, _plateCommon.someNode)(editor, {
      match: {
        type: (0, _plateCommon.getPluginType)(editor, _plateLink.ELEMENT_LINK)
      }
    })) {
      _plateLink.floatingLinkActions.show('edit', editor.id);
      floating.update();
      return;
    }
    if (_plateLink.floatingLinkSelectors.mode() === 'edit') {
      _plateLink.floatingLinkActions.hide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor, versionEditor, floating.update]);
  (0, _plateCommon.useHotkeys)(triggerFloatingLinkHotkeys, function (e) {
    if (_plateLink.floatingLinkSelectors.mode() === 'edit' && (0, _plateLink.triggerFloatingLinkEdit)(editor)) {
      e.preventDefault();
    }
  }, {
    enableOnContentEditable: true
  }, []);
  (0, _useFloatingLinkEnter.useFloatingLinkEnter)();
  (0, _useFloatingLinkEscape.useFloatingLinkEscape)();
  return {
    editButtonProps: {
      onClick: function onClick() {
        (0, _plateLink.triggerFloatingLinkEdit)(editor);
      }
    },
    props: {
      style: _objectSpread({}, floating.style, {
        zIndex: 5000
      })
    },
    ref: floating.refs.setFloating,
    unlinkButtonProps: {
      onClick: function onClick() {
        (0, _plateLink.unwrapLink)(editor);
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      }
    }
  };
};
exports.useFloatingLinkEdit = useFloatingLinkEdit;